<div class="account-page-template">
  <cx-page-slot position="NavigationAccount" />

  <div class="account-page-content">
    @switch (currentPage) {
      @case ('/my-orders') {
        <wc-my-orders (openRecommendedPriceModal)="openRecommendedPriceModal()" />
      }
      @case ('/return-products') {
        <wc-return-products (openRecommendedPriceModal)="openRecommendedPriceModal()" />
      }
      @case ('/my-account') {
        <wc-my-account-information />
      }
      @case ('/my-account-dashboard') {
        <wc-my-account-dashboard />
      }
      @case ('/my-products') {
        <wc-my-account-products />
      }
      @case ('/my-newsletters') {
        <div>
          <iframe
            width="100%"
            wcIframeResizer
            style="border: none"
            title="Newsletter Subscription"
            [attr.src]="newsletterLink"
            (load)="newsletterIsLoading = false"
          ></iframe>
          @if (newsletterIsLoading) {
            <div sd-loader></div>
          }
        </div>
      }
      @case ('/refer-a-friend') {
        <wc-my-account-sponsorships />
      }
    }
  </div>

  <cx-page-slot position="SEO" />
  <cx-page-slot position="DynamicBody" />
</div>

<wc-omnibus-recommended-price-modal [(isOpenedRecommendedPriceModal)]="isOpenedRecommendedModal" />
